import { useEffect, useState } from "react";
import { Button, Empty, Select, Spin } from "antd";
import { chatService } from "../../services/resources/chatService";
import { openNotification } from "../Notification";
import { ChatLiberacoesLista } from "./ChatLiberacoesLista";
import { paginaAjustadaLiberacao } from "./chatLiberacoesPaginacao";

export const ChatLiberacoesUsuarios = () => {
  const [contatos, setContatos] = useState([]);
  const [liberacoes, setLiberacoes] = useState([]);
  const [usuarioA, setUsuarioA] = useState();
  const [usuarioB, setUsuarioB] = useState();
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);

  async function carregar(paginaDesejada) {
    try {
      const [{ data: listaContatos }, { data: listaLiberacoes }] =
        await Promise.all([
          chatService.listarContatos(""),
          chatService.listarLiberacoes(),
        ]);
      const lista = listaLiberacoes || [];
      setContatos((listaContatos || []).filter((item) => !item.master));
      setLiberacoes(lista);
      setPagina((atual) =>
        paginaAjustadaLiberacao(lista.length, paginaDesejada ?? atual)
      );
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível carregar as liberações de usuários</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregar();
  }, []);

  async function conceder() {
    if (!usuarioA || !usuarioB) return;
    setSalvando(true);
    try {
      await chatService.concederLiberacao(usuarioA, usuarioB);
      setUsuarioA(undefined);
      setUsuarioB(undefined);
      await carregar(1);
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível liberar o diálogo</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setSalvando(false);
    }
  }

  async function desativar(codigo) {
    try {
      await chatService.desativarLiberacao(codigo);
      await carregar();
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível desativar a liberação</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    }
  }

  async function ativar(codigo) {
    try {
      await chatService.ativarLiberacao(codigo);
      await carregar();
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível ativar a liberação</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    }
  }

  const opcoes = contatos.map((contato) => ({
    value: contato.codigo,
    label: contato.nome,
  }));

  return (
    <section>
      <h3 className="chat-liberacoes__titulo">Usuários (1 a 1)</h3>
      <div className="chat-liberacoes__form">
        <Select
          showSearch
          allowClear
          loading={carregando}
          placeholder="Usuário padrão A"
          value={usuarioA}
          options={opcoes.filter((item) => item.value !== usuarioB)}
          optionFilterProp="label"
          onChange={setUsuarioA}
        />
        <Select
          showSearch
          allowClear
          loading={carregando}
          placeholder="Usuário padrão B"
          value={usuarioB}
          options={opcoes.filter((item) => item.value !== usuarioA)}
          optionFilterProp="label"
          onChange={setUsuarioB}
        />
        <Button
          type="primary"
          loading={salvando}
          disabled={carregando || !usuarioA || !usuarioB}
          onClick={conceder}
        >
          Liberar diálogo
        </Button>
      </div>
      {carregando ? (
        <div className="chat-vazio" role="status" aria-live="polite">
          <Spin />
        </div>
      ) : !liberacoes.length ? (
        <div className="chat-vazio">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhuma liberação 1 a 1"
          />
        </div>
      ) : (
        <ChatLiberacoesLista
          itens={liberacoes}
          pagina={pagina}
          onPagina={setPagina}
          rotulo={(item) => `${item.usuarioA?.nome} ↔ ${item.usuarioB?.nome}`}
          onAtivar={ativar}
          onDesativar={desativar}
        />
      )}
    </section>
  );
};
